export default __webpack_public_path__ + "static/media/logo-no-bg.0ccdff67.png";